import { takeLatest, call, put, cancelled } from 'redux-saga/effects';
import Api from '../../Api';
import { GET_EVENTS_FAIL, GET_EVENTS_REQUEST, GET_EVENTS_SUCCESS, GET_EVENTS_CANCEL } from '../actions/events';

export default function* watcher() {
  yield takeLatest(GET_EVENTS_REQUEST, getEvents);
}

function* getEvents(action) {
  const abortController = action.abortController;
  try {
    const { data } = yield call(Api.getEvents, action.payload, abortController ? { signal: abortController.signal } : {});

    yield put({
      type: GET_EVENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return;
    }
    
    console.warn(error, 'while getting events');

    let errorMessage = 'Unknown error';

    if (error.response) {
      errorMessage = error.response.data.message || 'Unknown server error';
    } else if (error.request) {
      errorMessage = 'No response from the server';
    } else {
      errorMessage = error.message || 'Unknown error';
    }

    yield put({
      type: GET_EVENTS_FAIL,
      payload: errorMessage,
    });
  } finally {
    if (yield cancelled()) {
      if (abortController) {
        abortController.abort();
      }
    }
  }
}
